/*!
 * Copyright (c) 2023 Digital Bazaar, Inc. All rights reserved.
 */
// WebCrypto
const crypto = globalThis.crypto;
export {crypto};
